import React from 'react'

export const pgaLabels = {
  TSCA: 'TSCA',
  LACEY: 'LACEY ACT',
  DISCLAIM_PGA: 'FDA DISCLAIM',
  NHTSA: 'DOT/NHTSA, REI',
  FDA_DEV: 'FDA DEV',
  FDA_FOO: 'FDA FOO',
  FDA_RAD: 'FDA RAD',
  DEA_DEA: 'DEA DEA',
  ATF_ATF: 'ATF',
  FDA_DRU: 'FDA DRU',
  APH_AVS: 'APH AVS',
  NMFS_SIM: 'NMFS SIM',
  APH_APQ: 'APH APQ',
  EPA_VNE: 'EPA VNE',
  EPA_ODS: 'EPA ODS',
  FDA_COS: 'FDA COS',
  FWS: 'FWS',
  EPA_PS1: 'EPA PS1',
  EPA_PS2: 'EPA PS2',
  EPA_PS3: 'EPA PS3',
  AMS_OR: 'AMS OR1', 
  AMS_OR2: 'AMS OR2',
  AMS_MO: 'AMS MO', 
  AMS_EG:'AMS EG',
  APH_AAC:'APH AAC',
  APH_ABS:'APH ABS',
  FDA_BIO:'FDA BIO',
  FDA_TOB:'FDA TOB',
  FDA_VME:'FDA VME',
  FSI_FSI:'FSI',
  NHT_MVS:'NHT MVS',
  NHT_OEI:'NHT OEI',
  NHT_REI:'NHT REI',
  NHT_OFF:'NHT OFF',
  NHT_TPE:'NHT TPE',
  NMF_370:'NMF 370',
  OMC_OMC:'OMC OMC',
  TTB_BER:'TTB BER',
  TTB_DSP:'TTB DSP',
  TTB_TOB:'TTB TOB',
  TTB_WIN:'TTB WIN',
  OMC_OMC: "OMC",
  NMF_370: "NMFS TTVP/370",
  NMFS_HMS: "NMFS HMS",
  NMFS_AMR: "NMFS AMR",
  commercialDesc: 'COMMERCIAL DESCRIPTION',
  charDesc: 'COMMODITY CHARACTERISTICS DESCRIPTION',
  indgredientUom: 'QUANTITY',
  individualName: 'NAME',
  telNumber: 'PHONE',
  email: 'EMAIL',
  entityAddress1: 'ADDRESS (23 CHAR MAX)',
  city: 'CITY',
  state: 'STATE',
  zip: 'ZIP',
  country: 'COUNTRY',
  dateOfSign: 'DATE OF SIGN',
  containerNum: 'CONTAINER NUMBER',
  genusName: 'GENUS NAME',
  speciesName: 'SPECIES NAME',
  countryCode: 'COUNTRY CODE',
  indgredientName: 'INGREDIENT NAME',
  indgredientQuantity: 'INGREDIENT QUANTITY',
  declarationCert: 'ELECTRONIC SUMMARY CERTIFICATION'
}

export const pgaHeaders = {
  laceyActHeader: <div>PGA Lacey Act Data Requirements</div>,
  laceyActSubHeader: <div>GOVT AGENCY CODE: <b>APH</b> GOVT. AGENCY PROGRAM CODE <b>APL</b></div>,
  tscaHeader: <div>PGA TSCA Certification</div>,
  tscaSubHeader: <React.Fragment>Government Agency <b>EPA</b> GOVT. AGENCY PROGRAM CODE <b>TS1</b></React.Fragment>,
  fdaHeader: <div>PGA FDA Disclaim</div>,
  fdaSubHeader: <div>General program code only allowed to be used when disclaiming</div>,
  nhtsaHeader: <div>PGA DOT/NHTSA, REI Certification</div>,
  nhtsaSubHeader: <React.Fragment>Regulated motor vehicle equipment items that are subject to the Federal motor vehicle safety standards</React.Fragment>,
  deaDeaHeader: <div>PGA: DEA is required. Complete and select DONE to verify.</div>,
  deaDeaSubHeader: <React.Fragment>GOVT AGENCY CODE: <b>DEA</b> <br />The HTS code for your product has flagged DEA. Please complete the following form.</React.Fragment>,
  fwsFwsHeader: <div>FWS is required. Complete and select DONE to verify.</div>,
  fwsFwsSubHeader: <React.Fragment>GOVT AGENCY CODE: <b>FWS</b> GOVT. AGENCY PROGRAM CODE <b>FWS</b><br />The HTS code for your product has flagged FWS. Please complete the following form.</React.Fragment>,
  fdaCosHeader: <div>FDA: COS is required. Complete and select DONE to verify.</div>,
  fdaCosSubHeader: <React.Fragment>GOVT AGENCY CODE: <b>FDA</b> GOVT. AGENCY PROGRAM CODE <b>COS</b><br />The HTS code for your product has flagged COS. Please complete the following form.</React.Fragment>,
  genericHeader: function(first,second){
    if(second == "OR")second = "OR1"
    return <div>{first}: {(second!==first)?<>{second} is required.</>:<></>} Complete and select DONE to verify.</div>
  },
  genericSubHeader: function(first,second){
    if(second == "OR")second = "OR1"
    if(first==second){
      return  <React.Fragment>GOVT AGENCY CODE: <b>{first}</b>. <br />The HTS code for your product has flagged {first}. Please complete the following form.</React.Fragment>
    }
    return  <React.Fragment>GOVT AGENCY CODE: <b>{first}</b> GOVT. AGENCY PROGRAM CODE <b>{second}</b><br />The HTS code for your product has flagged {first} {second}. Please complete the following form.</React.Fragment>
  },
  }

export const pgaErrors = {
  incompletePGAMessage: 'PGA is required. Complete and select DONE to verify.',
  manualPGAMessage: 'PGA is voluntary. Complete and select DONE to verify.',
  completePGAMessage: 'Completed.',
  pgaRequiredFieldError: 'This field is required to transmit PGA.',
  entityAddress1TooLong: 'Address cannot be more than 23 chars.',
  pgaHeaderMessage: 'There were some errors with your submission. Please resolve and select DONE.',
  needCertification: 'Your certification is needed.'
}